import template from './changePassword.html';
import controller from './changePassword.controller';
import './changePassword.scss';

let changePasswordComponent = {
  bindings: {},
  template,
  controller
};

export default changePasswordComponent;



// WEBPACK FOOTER //
// ./client/app/components/changePassword/changePassword.component.js